<template>
    <div id="app" :class="$route.name">
        <router-view/>
        <app-nav/>
    </div>
</template>

<script>
import ogImage from '@/assets/og.jpg'
import AppNav from '@/components/AppNav'

export default {
    name: 'App',
    components: {
        AppNav,
    },
    metaInfo: {
        title: '오늘은 경리단, 아는동네 로컬 프로젝트',
        meta: [
            { property: 'og:title', content: '오늘은 경리단, 아는동네 로컬 프로젝트' },
            { property: 'og:description', content: '오늘은 경리단길에서 놀자! 경리단길 내 다양한 로컬 스팟을 중심으로 지역에서 활동하는 크리에이터들과 함께 동네를 자세히 보고 즐기는 특별한 기회. ‘오늘은 경리단’은 경리단 클래스, 경리단 쿠폰북, 경리단 굿즈 등의 프로그램을 통해 경리단길만의 특별한 콘텐츠를 소개합니다.', vmid: 'og:description' },
            { property: 'og:image', content: ogImage, vmid: 'og:image' },
            { property: 'og:image:alt', content: '오늘은 경리단, 아는동네 로컬 프로젝트', vmid: 'og:image:alt'}
        ]
    },
    watch: {
        $route() {
            if (this.$route.name === 'about') {
                document.querySelector('html').style.overflow = 'hidden'
            }
            else {
                document.querySelector('html').style.overflow = 'auto'
            }
        }
    },
}
</script>

<style lang="scss">
@import '~@/styles/_parts';

#app {
    min-height: 100%;
    position: relative;
    overflow: hidden;
    &.map {
        height: 100%;
        @include footer-pad();
    }
    &.about {
        height: 100%;
        @include media(992) {
            .app-nav {
                background: none;
            }
        }
    }
}

.app-nav {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 5;
}

.vb > .vb-dragger {
    z-index: 5;
    width: 12px;
    right: 0;
}

.vb > .vb-dragger > .vb-dragger-styler {
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-transform: rotate3d(0,0,0,0);
    transform: rotate3d(0,0,0,0);
    -webkit-transition:
            background-color 100ms ease-out,
            margin 100ms ease-out,
            height 100ms ease-out;
    transition:
            background-color 100ms ease-out,
            margin 100ms ease-out,
            height 100ms ease-out;
    background-color: rgba(0, 0, 0,.1);
    margin: 5px 5px 5px 0;
    border-radius: 20px;
    height: calc(100% - 10px);
    display: block;
}

.vb.vb-scrolling-phantom > .vb-dragger > .vb-dragger-styler {
    background-color: rgba(0, 0, 0,.3);
}

.vb > .vb-dragger:hover > .vb-dragger-styler {
    background-color: rgba(0, 0, 0,.5);
    margin: 0px;
    height: 100%;
}

.vb.vb-dragging > .vb-dragger > .vb-dragger-styler {
    background-color: rgba(0, 0, 0,.5);
    margin: 0px;
    height: 100%;
}

.vb.vb-dragging-phantom > .vb-dragger > .vb-dragger-styler {
    background-color: rgba(0, 0, 0,.5);
}
</style>
